import countries from './countries'
import gpc from './gpc'
import lang from './lang'
import uom from './uom'

export default {
  countries,
  gpc,
  lang,
  uom,
  message: {
    my_token: 'API',
    create_new_token: 'Token erstellen',
    tokens: 'Token',
    revocation: 'Widerruf',
    username: 'Nutzername',
    comapany_name: 'Unternehmen',
    token_id: 'Token Nummer',
    no_token_found: 'Keine Token gefunden',
    loading: 'Läd gerade...',
    token_description_1:
      'Mit der Verified by GS1 API haben Sie die Möglichkeit automatisiert Produktinformationen aus',
    registry_platform: 'der GS1 Registry Plattform',
    before_swagger_link: 'abzufragen. Die technische Dokumentation finden Sie ',
    token_description_2:
      'Bitte erstellen Sie sich auf dieser Seite Token, welche Sie zum Zugriff auf die API nutzen können.',
    token_description_3: 'hier',
    token_tooltip:
      'Hier können Sie Authentifizierungstoken zum Zugriff auf die API erstellen.',
    api_docs_tooltip:
      'Technische Beschreibung der Computerschnittstelle der Applikation zur Integration in ihre Anwendung.',
    // Modal Token confirm
    modal_confirm_token_title: 'Token löschen',
    modal_confirm_token_text: 'Möchten Sie diesen Token wirklich löschen?',
    modal_confirm_token_confirm_button: 'OK',
    modal_confirm_token_cancel_button: 'Abbrechen',
    copy: 'Kopieren',
    signing_in: 'Anmeldung läuft…',
    auth_failed: 'Anmeldung fehlgeschlagen',
    try_again: 'Erneut versuchen',
    auth_loop_detected: 'Authentifizierungs-Schleife erkannt',
    auth_loop_message:
      'Es wurde eine Weiterleitungs-Schleife bei der Anmeldung festgestellt. Dies deutet meist auf ein Problem mit der Server-Konfiguration hin. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.',
    go_to_homepage: 'Zur Startseite'
  },
  glnType: {
    LEGAL_ENTITY_text: 'Juristische Person',
    FUNCTION_text: 'Funktion',
    FIXED_PHYSICAL_LOCATION_text: 'Feste physische Lokation',
    MOBILE_PHYSICAL_LOCATION_text: 'Mobile physische Lokation',
    DIGITAL_LOCATION_text: 'Digitale Lokation'
  },
  locationIdType: {
    UN_LOCODE_title: 'UN/LOCODE',
    IMO_NUMBER_title: 'Nummer der Internationalen Seeschifffahrtsorganisation',
    OPEN_LOCATION_CODE_title: 'Offener Standortcode',
    OAR_ID_title: 'OAR-ID',
    OAR_ID_tooltip: 'Kennung des offenen Bekleidungsregisters'
  },
  organizationIdType: {
    EU_VAT_IDENTIFICATION_NUMBER_title:
      'EU-Mehrwertsteuer-Identifikationsnummer',
    APE_title: 'Activite Principale Exercee (APE)',
    EORI_title:
      'Registrierungs- und Identifikationsnummer für Wirtschaftsbeteiligte',
    PHYTOSANITARY_NUMBER_title: 'Phytosanitäre Registrierungsnummer',
    SEC_title: 'U.S. Securities and Exchange Commission',
    CAGE_title: 'Kommerzielle und staatliche Einrichtung',
    DoDAAC_title: 'Adresscode der Aktivität des Verteidigungsministeriums',
    LEI_title: 'Kennung der juristischen Person (LEI)',
    APE_NISE_title: "Activite Principale de l'Entreprise",
    NAF_title: 'Nomenclature des Activités Françaises',
    RCS_title:
      'Handels- und Gesellschaftsregister (Registre du commerce et des sociétés)',
    SIREN_title: "Système d'identification du répertoire des entreprises",
    SIRET_title:
      "Système d'identification du répertoire des établissements (System zur Identifizierung des Unternehmensregisters)",
    BFA_title: 'Biologische Landwirte in Australien',
    BIOLAND_title: 'Bioland',
    DEMETER_BUND_title: 'Demeter-Bund',
    DEMETER_INTERNATIONAL_title: 'Demeter-Ausland',
    ECOLAND_title: 'Ökoland',
    ECOVIN_title: 'Ecovin',
    EPA_title: 'US-Umweltschutzbehörde',
    FDA_title: 'FDA US-Lebensmittel- und Arzneimittelbehörde',
    FSA_title: 'UK Agentur für Lebensmittelstandards (FSA)',
    GAA_title: 'GAA',
    IFOA_title: 'Internationale Stiftung für ökologischen Landbau',
    IFOAM_title: 'Internationaler Verband der ökologischen Landbaubewegungen.',
    NATURLAND_title: 'Naturland',
    QAI_title: 'Internationale Qualitätssicherungsstelle',
    SUDITIROL_title: 'Sudtirol Bioland',
    USDA_title: 'US-Landwirtschaftsministerium',
    DUNS_title: 'DUNS',
    DUNS_PLUS_FOUR_title: 'DUNS+4',
    EO_ID_title: 'Identifikator des Wirtschaftsbeteiligten',
    EST_NUMBER_title: 'USDA Niederlassungsnummer',
    US_EIN_title: 'Identifikationsnummer des Arbeitgebers (EIN)',
    US_RSSD_ID_title: 'Replikationsserver-Systemdatenbank-ID (RSSD-ID)',
    US_CRD_title: 'CRD-Nummern (Central Registration Depository)',
    US_MIC_title: 'Hersteller-Identifikationscode (MIC)',
    US_UEI_title: 'Eindeutige Identifikationsnummer (UEI)',
    US_SCAC_title: 'Standard-Carrier-Alpha-Code (SCAC)',
    US_HTS_title:
      'Nummer des Harmonisierten Zolltarifs (HTS) und Codes der Liste B',
    US_EPA_ID_title: 'EPA-Identifikationsnummer',
    US_FDIC_title:
      'Zertifikatsnummer der Federal Deposit Insurance Corporation (FDIC)',
    US_CID_title: 'Unternehmensidentifikator (CID)',
    US_NPI_title: 'Nationale Anbieter-Identifikationsnummer (NPI)',
    US_DEA_title: 'Drug Enforcement Administration (DEA) Nummer',
    US_FEI_title: 'FDA-Betriebskennung (Facility FEI)',
    IFTP_title: 'Internationale Fischerei-Handelsgenehmigung (IFTP) Nummer',
    US_MFG_ID_title: 'Hersteller-ID',
    US_FCC_FRN_title: 'FCC-Registrierungsnummer (FRN)',
    US_499_Filler_ID_title: '499 Antragsteller-ID',
    US_498_ID_title:
      'Identifikationsnummer des Dienstanbieters und der abgerechneten Einheit (FCC Form 498 ID)',
    US_RN_title: 'Registrierte Identifikationsnummer (RN)',
    IATA_CODE_title: 'Code der Internationalen Luftverkehrsvereinigung (IATA)',
    US_LIC_title: 'Etikettierer-Identifikationsnummer (LIC)',
    BEA_ID_title:
      'BEA Identifikationsnummer für ausländische Direktinvestitionen',
    FMC_ID_title: 'FMC-Lizenznummer',
    GIIN_title: 'Globale Vermittler-Identifikationsnummer (GIIN)',
    US_FHFA_ID_title: 'FHFA ID-Nummer',
    US_MINE_ID_title: 'U.S. Minen-ID',
    US_LAB_ID_title: 'U.S. Labor ID',
    KVK_NUMBER_title: 'Kamer van Koophandel (KVK) Nummer',
    OIN_NUMBER_title: 'Organisatie-identificatienummer (OIN-Nummer)',
    CRN_title: 'Registrierungsnummer für Unternehmen',
    TIN_title: 'Steuerzahler-Identifikationsnummer',
    DID_title: 'Dezentrale Identifikationsnummer'
  },
  locationType: {
    ACCOUNTS_DEPARTMENT_title: 'Abteilung Buchhaltung',
    WASTE_CENTER_title: 'Abfallzentrum',
    AGED_CARE_SERVICE_title: 'Altenpflege',
    WHARF_title: 'Werft',
    RESEARCH_FACILITY_title: 'Forschungseinrichtung',
    AIRCRAFT_title: 'Flugzeuge',
    AIRPORT_title: 'Flughafen',
    AIRPORT_GATE_title: 'Flughafentor',
    AMBULANCE_SERVICE_title: 'Ambulanzdienst',
    AMUSEMENT_ENTERTAINMENT_GAMING_title:
      'Vergnügungsstätte Unterhaltung Spiel',
    CASH_CARRY_title: 'Bargeld und Transportmittel',
    DOCTOR_OFFICE_title: 'Arztpraxis',
    AREA_HEALTH_title: 'Bereich Gesundheit',
    ASSEMBLY_title: 'Montage',
    BOTTLING_title: 'Flaschenabfüllung',
    BERTH_title: 'Liegeplatz',
    BIRTH_AREA_title: 'Geburtsbereich',
    BOAT_title: 'Boot',
    BANK_title: 'Bank',
    ATM_title: 'Geldautomat',
    CITY_CENTRE_SHOP_title: 'Geschäft im Stadtzentrum',
    CLINIC_title: 'Klinik',
    COLLECTION_CENTRE_title: 'Sammelstelle',
    CONSOLIDATING_CENTRE_title: 'Konsolidierungszentrum',
    CONSTRUCTION_SITE_title: 'Baustelle',
    CONVENIENCE_STORE_title: 'Verbrauchermarkt',
    CORRECTION_FACILITY_title: 'Justizvollzugsanstalt',
    DENTAL_HEALTH_SERVICE_title: 'Zahnärztlicher Dienst',
    DISTRIBUTION_CENTRE_title: 'Vertriebszentrum',
    DRUG_STORE_title: 'Drogerie',
    DUTY_FREE_STORE_title: 'Duty-Free-Laden',
    EARLY_CHILDHOOD_EDUCATING_AND_CENTRE_title:
      'Frühkindliche Bildung und Zentrum',
    EDUCATION_FACILITY_title: 'Bildungseinrichtung',
    EMERGENCY_DEPARTMENT_title: 'Notaufnahme',
    FARM_title: 'Bauernhof',
    VINEYARD_title: 'Weinberg',
    FEED_LOT_title: 'Futterplatz',
    FIELD_title: 'Feld',
    FOOD_BUSINESS_title: 'Lebensmittelgeschäft',
    FREIGHT_TERMINAL_title: 'Frachtterminal',
    FREIGHT_HUB_title: 'Güterverkehrszentrum',
    GARDEN_CENTRE_title: 'Gartencenter',
    GOVERNMENT_DEPARTMENT_AGENCY_title: 'Regierungsabteilung Agentur',
    GREENHOUSE_title: 'Gewächshaus',
    HEAD_OFFICE_title: 'Hauptverwaltung',
    HOSPITAL_title: 'Krankenhaus',
    HOSPITAL_DEPARTMENT_title: 'Krankenhausabteilung',
    HOSPITAL_PHARMACY_title: 'Krankenhausapotheke',
    HOSPITAL_CAFETERIA_title: 'Krankenhaus-Cafeteria',
    IMAGING_DIAGNOSTICS_title: 'Bildgebende Diagnostik',
    IMPREST_LOCATION_title: 'Zahlstelle',
    INLAND_FISHERY_title: 'Binnenfischerei',
    INBOUND_AND_OUTBOUND_DOCK_title:
      'Dock für eingehende und ausgehende Sendungen',
    INBOUND_DOCK_title: 'Eingehendes Dock',
    INTERMODAL_TERMINAL_title: 'Intermodales Terminal',
    LIBRARY_title: 'Bibliothek',
    LANE_OR_ROUTE_title: 'Fahrspur oder Route',
    MAIN_RECEPTION_title: 'Hauptempfang',
    MANUFACTURING_PLANT_title: 'Produktionsstätte',
    MARINE_FISHERY_title: 'Seefischerei',
    MARKET_title: 'Markt',
    MENTAL_HEALTH_SERVICE_title: 'Psychiatrischer Dienst',
    MILKING_SITE_title: 'Melkstand',
    NURSE_STATION_title: 'Krankenpflegestation',
    OFFICE_title: 'Büro',
    OPERATING_THEATRE_title: 'Operationssaal',
    OUTBOUND_DOCK_title: 'Dock im Ausgang',
    PACKHOUSE_title: 'Packhaus',
    PATHOLOGY_title: 'Pathologie',
    PERSONAL_SERVICES_title: 'Persönliche Dienste',
    PETROL_STATION_title: 'Tankstelle',
    RETAIL_PHARMACY_title: 'Einzelhandelsapotheke',
    POINT_OF_SALE_title: 'Verkaufsstelle',
    PRIMARY_HEALTH_SERVICE_title: 'Primärer Gesundheitsdienst',
    PRODUCTION_LINE_title: 'Fließband',
    PUBLIC_WAREHOUSE_title: 'Öffentliches Lagerhaus',
    RAIL_STATION_title: 'Bahnstation',
    REARING_AREA_title: 'Aufzuchtbereich',
    REPACKER_title: 'Umschlagplatz',
    RESIDENCE_title: 'Wohnsitz',
    RETAIL_OUTLET_title: 'Einzelhandelsgeschäft',
    RETURNABLE_ASSET_SERVICE_CENTRE_title: 'Mehrweg-Servicezentrum',
    SEAPORT_title: 'Seehafen',
    SELF_SERVICE_title: 'Selbstbedienung',
    SERVICE_COUNTER_title: 'Service-Schalter',
    SILO_title: 'Silo',
    SLAUGHTER_HOUSE_title: 'Schlachthof',
    SPORTS_AND_RECERATIONAL_title: 'Sport und Freizeit',
    STATION_title: 'Bahnhof',
    STOCKING_LOCATION_title: 'Lagerungsort',
    STORAGE_LOCATION_title: 'Lagerort',
    STORE_title: 'Lager',
    TERMINAL_title: 'Terminal',
    TRADE_ITEM_RETURN_LOCATION_title: 'Handel Artikel Rückgabe Ort',
    TRAIN_title: 'Zug',
    VENDING_title: 'Verkaufsautomat',
    VENDOR_LEASED_SPACE_title: 'Vermietete Fläche des Verkäufers',
    VISITING_ADDRESS_title: 'Besuchsadresse',
    WARD_title: 'Station',
    WAREHOUSE_AND_OR_DEPOT_title: 'Lager und/oder Depot',
    SALES_YARD_title: 'Verkaufshof',
    RECEIVING_LOCATION_title: 'Empfangsort',
    BACKROOM_title: 'Hinterzimmer',
    STORAGE_AREA_title: 'Lagerbereich',
    SALES_FLOOR_title: 'Verkaufsfläche',
    RETURNS_AREA_title: 'Retourenbereich',
    PRODUCTION_AREA_title: 'Produktionsbereich',
    RECEIVING_AREA_title: 'Empfangsbereich',
    SHIPPING_AREA_title: 'Versandbereich',
    SALES_FLOOR_TRANSITION_AREA_title: 'Verkaufsfläche Übergangsbereich',
    CUSTOMER_PICK_UP_AREA_title: 'Kundenabholbereich',
    YARD_title: 'Werft',
    CONTAINER_DECK_title: 'Container-Deck',
    CARGO_TERMINAL_title: 'Frachtterminal',
    PACKAGING_AREA_title: 'Verpackungsbereich',
    PICKING_AREA_title: 'Kommissionierbereich',
    ELECTRONICS_AREA_title: 'Elektronik-Bereich',
    SHELF_title: 'Regal',
    PROMOTION_AREA_title: 'Promotion-Bereich',
    END_CAP_AREA_title: 'Endkappen-Bereich',
    SECURITY_AREA_title: 'Sicherheitsbereich',
    GENERAL_MDSE_AREA_title: 'Bereich für allgemeine Handelswaren',
    GROCERY_title: 'Lebensmittelgeschäft',
    BOX_CRUSHER_title: 'Kistenbrecher',
    CONVEYOR_BELT_title: 'Förderband',
    PALLET_WRAPPER_title: 'Paletteneinwickler',
    FIXED_READER_title: 'Festes Lesegerät',
    MOBILE_READER_title: 'Mobiles Lesegerät',
    STAGING_title: 'Bereitstellen',
    LAY_AWAY_title: 'Einlagerung',
    DISPENSER_title: 'Spender',
    QUARANTINE_title: 'Quarantäne',
    CONTROLLED_SUBSTANCE_AREA_title: 'Bereich für kontrollierte Substanzen',
    RECALLED_PRODUCT_AREA_title: 'Bereich für zurückgerufene Produkte',
    QUALITY_CONTROL_title: 'Qualitätskontrolle',
    PRINTING_ROOM_title: 'Druckraum',
    ENTRANCE_GATE_title: 'Eingangstor',
    EXIT_GATE_title: 'Ausgangstor',
    GATE_title: 'Tor',
    READ_POINT_VERIFICATION_SPOT_title: 'Lesepunkt Verifizierungsstelle',
    // org titles
    ACCEPTING_PARTY_title: 'Annehmende Organisation',
    BILL_OF_LADING_RECIPIENT_title: 'Konnossement-Empfänger',
    BILL_TO_title: 'Rechnung an',
    BRAND_OWNER_title: 'Besitzer der Marke',
    BREEDER_title: 'Züchter',
    BROKER_AGENT_title: 'Makler-Agent',
    BUYER_title: 'Käufer',
    BUYERS_AGENT_REPRESENTATIVE_title: 'Käufer-Agent-Vertreter',
    CARRIER_title: 'Träger',
    CLINICAL_TRIAL_SPONSOR_title: 'Sponsor einer klinischen Studie',
    CENTRAL_PAYMENT_SERVICE_title: 'Zentraler Zahlungsdienst',
    CHECKING_PARTY_title: 'Kontrollierende Organisation',
    CHEQUE_ORDER_title: 'Scheck Auftrag',
    CONSIGNEE_title: 'Empfänger',
    CONSIGNOR_title: 'Absender',
    CONSOLIDATOR_title: 'Konsolidierer',
    CONSUMER_title: 'Verbraucher',
    CORPORATE_IDENTITY_title: 'Unternehmensidentität',
    CUSTOMS_title: 'Zollbehörden',
    RECALL_RECIPIENT_title: 'Rückruf-Empfänger',
    RECALL_SPONSOR_title: 'Sponsor des Rückrufs',
    CUSTOMS_BROKER_title: 'Zollmakler',
    CUTTER_title: 'Kutter',
    DECLARANTS_AGENT_REPRESENTATIVE_title: 'Vertreter des Anmelders Vertreter',
    DELIVERY_PARTY_title: 'Organisation der Lieferung',
    DESIGNER_title: 'Designer',
    DESPATCH_PARTY_title: 'Organisation für den Versand',
    DISTRIBUTOR_title: 'Vertriebshändler',
    DOCK_DOOR_title: 'Verladerampe',
    EMPTY_EQUIPMENT_DESPATCH_PARTY_title:
      'Organisation für den Versand von leeren Geräten',
    EMPTY_EQUIPMENT_RETURN_PARTY_title: 'Leergut-Rückgabeorganisation',
    EQUIPMENT_OWNER_title: 'Besitzer des Equipments',
    EXPORTER_title: 'Ausführer',
    FACTOR_title: 'Fabrikant',
    FATTENER_title: 'Mäster',
    FREIGHT_FORWARDER_title: 'Spediteur',
    GOODS_OWNER_title: 'Eigentümer der Waren',
    GROWER_title: 'Züchter',
    HEALTHCARE_PROVIDER_title: 'Gesundheitsdienstleister',
    IMPORTER_title: 'Importeur',
    INFORMATION_PROVIDER_title: 'Informationsanbieter',
    INSURER_title: 'Versicherer',
    INTERMEDIARY_BANK_title: 'Vermittler Bank',
    RETAILER_title: 'Einzelhändler',
    MARKETPLACE_OPERATOR_title: 'Marktplatz-Betreiber',
    FOODSERVICE_OPERATOR_title: 'Foodservice-Betreiber',
    FOODSERVICE_DISTRIBUTOR_title: 'Lebensmitteldienstleister',
    PHARMACY_OPERATOR_title: 'Apotheke Betreiber',
    FARM_OPERATOR_title: 'Landwirt',
    HARVESTER_title: 'Erntehelfer',
    FISHING_OPERATOR_title: 'Fischereibetrieb',
    INVENTORY_CONTROLLER_title: 'Inventar-Controller',
    INVENTORY_REPORTING_PARTY_title: 'Organisation für Inventurberichte',
    INVOICEE_title: 'Rechnungsempfänger',
    ISSUER_OF_INVOICE_title: 'Aussteller der Rechnung',
    LOGISTICS_SERVICE_PROVIDER_title: 'Logistikdienstleister',
    MANUFACTURER_OF_GOODS_title: 'Hersteller von Waren',
    MARK_FOR_title: 'Mark für',
    MESSAGE_FROM_title: 'Nachricht von',
    MESSAGE_RECIPIENT_title: 'Empfänger der Nachricht',
    MINCER_title: 'Fleischwolf',
    OPERATING_DIVISION_title: 'Betriebsabteilung',
    OPERATOR_title: 'Betreiber',
    ORDERING_PARTY_title: 'Bestellende Organisation',
    OWNER_OF_EQUIPMENT_title: 'Eigentümer der Ausrüstung',
    OWNER_OF_MEANS_OF_TRANSPORT_title: 'Eigentümer des Transportmittels',
    PARTY_DECLARING_THE_VALUE_ADDED_TAX_title:
      'Organisation, die die Steuer erklärt',
    PARTY_FOR_WHOM_ITEM_IS_ULTIMATELY_INTENDED_title:
      'Organisation, für die der Artikel letztendlich bestimmt ist',
    PARTY_RECEIVING_PRIVATE_DATA_title:
      'Organisation, die private Daten erhält',
    PARTY_RECOVERING_THE_VALUE_ADDED_TAX_title:
      'Organisation zur Rückerstattung der Steuer',
    PARTY_TO_RECEIVE_ALL_DOCUMENTS_title:
      'Organisation zum Erhalt aller Dokumente',
    PARTY_TO_RECEIVE_COMMERCIAL_INVOICE_title:
      'Organisation zum Erhalt einer Handelsrechnung',
    PARTY_TO_RECEIVE_ELECTRONIC_MEMO_OF_INVOICE_title:
      'Organisation, die eine elektronische Rechnungsnachricht erhalten soll',
    PARTY_TO_RECEIVE_FREIGHT_BILL_title:
      'Organisation zum Erhalt von Frachtbriefen',
    PARTY_TO_RECEIVE_REFUND_title: 'Organisation, die eine Erstattung erhält',
    PAYEE_title: 'Zahlungsempfänger',
    PAYER_title: 'Zahler',
    PRICE_LOCATION_PARTY_title: 'Preis Standort Organisation',
    PROXY_title: 'Bevollmächtigter',
    PURCHASE_ORDER_RECEIVER_title: 'Bestellung Empfänger',
    PACKER_title: 'Verpacker',
    TRADER_title: 'Händler',
    REGISTERED_AGENT_title: 'Registrierter Vertreter',
    REMIT_TO_title: 'Überweisung an',
    SELLER_title: 'Verkäufer',
    SERVICE_PROVIDER_title: 'Dienstleister',
    SLAUGHTERER_title: 'Schlachthofbetreiber',
    E_TAILER_title: 'E-Tailer',
    STORAGE_AND_HANDLING_title: 'Lagerung und Umschlag',
    AGRICULTURAL_COOPERATIVE_title: 'Landwirtschaftliche Genossenschaft',
    CASH_TRANSPORT_SERVICES_title: 'Bargeldtransportdienste',
    SUBSTITUTE_SUPPLIER_title: 'Substitutionslieferant',
    SUPPLIER_title: 'Lieferant',
    TRANSPORTATION_CARRIER_title: 'Transportunternehmen',
    WAREHOUSE_KEEPER_title: 'Lagerverwalter',
    WHOLESALER_title: 'Großhändler',
    SHIP_FROM_title: 'Versand von',
    SHIP_TO_title: 'Versand nach'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/de/index.js